import type { TourId, TourStepId, TourTargetKey } from "./tourguide.types";

function targetKey(tourId: TourId, stepId: TourStepId): TourTargetKey {
  return `${tourId}:${stepId}`;
}

function firstStepId(stepIds: TourStepId[]): TourStepId | null {
  return stepIds[0] ?? null;
}

function nextStepId(
  stepIds: TourStepId[],
  activeStepId: TourStepId | null,
): TourStepId | null {
  if (!activeStepId) {
    return firstStepId(stepIds);
  }

  const activeIndex = stepIds.indexOf(activeStepId);

  if (activeIndex === -1) {
    return firstStepId(stepIds);
  }

  return stepIds[activeIndex + 1] ?? null;
}

function previousStepId(
  stepIds: TourStepId[],
  activeStepId: TourStepId | null,
): TourStepId | null {
  if (!activeStepId) {
    return null;
  }

  const activeIndex = stepIds.indexOf(activeStepId);

  if (activeIndex <= 0) {
    return activeStepId;
  }

  return stepIds[activeIndex - 1] ?? activeStepId;
}

function preservesActiveStep(
  stepIds: TourStepId[],
  activeStepId: TourStepId | null,
): TourStepId | null {
  if (!activeStepId) {
    return null;
  }

  return stepIds.includes(activeStepId) ? activeStepId : null;
}

export const TourGuideEntity = {
  firstStepId,
  nextStepId,
  previousStepId,
  preservesActiveStep,
  targetKey,
} as const;
